import {
  ActionIcon,
  Container,
  createStyles,
  Flex,
  Group,
  Image,
  Text,
} from "@mantine/core";
import { MdFacebook, MdWhatsapp } from "react-icons/md";

type Props = {
  whatsappLink?: string;
  facebookLink?: string;
};

const useStyles = createStyles((theme) => ({
  footer: {
    backgroundColor: "whitesmoke",
    padding: theme.spacing.xl,
  },

  inner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,

    [theme.fn.smallerThan("xs")]: {
      flexDirection: "column",
    },
  },

  links: {
    [theme.fn.smallerThan("xs")]: {
      marginTop: theme.spacing.md,
    },
  },
}));

export default function Footer({ whatsappLink, facebookLink }: Props) {
  const { classes } = useStyles();

  return (
    <div className={classes.footer}>
      <Container className={classes.inner}>
        <Flex align="center" gap={8}>
          <Image
            src="/logo512.png"
            alt="master wong logo"
            height={32}
            width="auto"
          />
          <Text color="#002C2E" fw="bold">
            Master Wong 黃絲傅冷氣
          </Text>
        </Flex>
        <Group spacing={0} className={classes.links} position="right" noWrap>
          {whatsappLink && (
            <ActionIcon
              size="sm"
              component="a"
              href={whatsappLink}
              target="_blank"
            >
              <MdWhatsapp size="sm" stroke="1.5" />
            </ActionIcon>
          )}
          {facebookLink && (
            <ActionIcon
              size="sm"
              component="a"
              href={facebookLink}
              target="_blank"
            >
              <MdFacebook size="sm" stroke="1.5" />
            </ActionIcon>
          )}
        </Group>
      </Container>
      <Text align="center" size="xs" c={"dimmed"}>
        Copyright © 2023 LAB-503.com. All Rights Reserved
      </Text>
    </div>
  );
}
